module.exports = __webpack_public_path__ + "static/favicon-384fc75b8e5f9f6792a45d104278e99d.ico";